<template>
  <div v-loading="loadingNotifications">
    <div class="govgr-header__container" style="color: #fff">
    <div class="govgr-header__content">
      <a href="https://www.gov.gr/">
        <img class="govgr-header-logo" src="https://www.gov.gr/gov_gr_logo.svg" />
      </a>  
      <a href="https://e-doatap.doatap.gr">
        <img class="govgr-header-secondary-logo" src="../assets/Logo-eDoatap_Color_white-letters.png" />
         <el-dialog
      title="ΟΡΟΙ ΚΑΙ ΠΡΟΫΠΟΘΕΣΕΙΣ ΧΡΗΣΗΣ ΤΟΥ e-doatap"
      :visible.sync="termsDialogVisible"
    >
    </el-dialog>
      </a>  
    </div>
        <span class="navbar-user hidden-xs-only" v-if="currentUser">
      {{ currentUser.name }}
    </span>
    <span v-if="currentUser">  
      <span class="hideInMd small-margin" v-if="currentUser && existsApplications">
        {{ $t('myApps') }}
      </span>
      <el-badge :value="usersAllApplications.length" @mouseover.native="$refs.allApps.focus()">
        <el-select
          ref="allApps"
          :automatic-dropdown="true"
          class="hideInMd"
          v-model="selectApplication"
          :placeholder="activeApplication"
          v-if="currentUser && existsApplications"
          @change="newApplicationSelected"
          size="small"
        >
        <!-- app protocol number shown in  list, if not defined show app id instead -->
          <el-option
            v-for="application in usersAllApplications"
            :key="application.id"
            :label="`${application.protocol ? application.protocol : application.id}: ${activeLocale === 'el' ? application.grApplicationType : application.engApplicationType} `"
            :value="application.id"
          >
          </el-option>
        </el-select>
      </el-badge>
      
      <countdown
        class="clock small-margin"
        v-if="currentUser"
        :time="prettyTime"
      ></countdown>
    </span>
    <span v-if="currentUser && appHasRoom">
      <el-badge v-if="haveNewMessages" :value="newWord" class="item">
        <el-button :type="notificationsType" icon="el-icon-message" @click="listAllNotifications">
        </el-button>
      </el-badge>
      <el-button v-else :type="notificationsType" icon="el-icon-message" @click="listAllNotifications">
      </el-button>
    </span>
    <el-dialog :title="notifications" v-if="currentUser"
      :visible.sync="chatDialogVisible" width = "95%">
      <Chat />
    </el-dialog>
    <span class="navbar-account">
      <el-dropdown v-if="currentUser" trigger="click">
        <span class="el-dropdown-link" style="color: #fff">
          {{ $t('options') }}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <span class="showInMd" v-if="currentUser && existsApplications">{{
              $t('myApps')
            }}</span>
            <el-select
              class="showInMd"
              v-model="selectApplication"
              filterable
              :placeholder="activeApplication"
              v-if="currentUser && existsApplications"
              @change="newApplicationSelected"
              size="small"
            >
              <el-option
                v-for="application in usersAllApplications"
                :key="application.id"
                :label="application.applicationType.substring(0, 30) + '...'"
                :value="application.id"
              >
              </el-option>
            </el-select>
          </el-dropdown-item>
          <el-dropdown-item>
            <el-radio-group v-model="activeLocale" size="mini" @click.native.stop>
              <el-radio-button label="el">{{ $t('greek_dropdown') }}</el-radio-button>
              <el-radio-button label="en">{{ $t('english_dropdown') }}</el-radio-button>
            </el-radio-group>
          </el-dropdown-item>
          <el-dropdown-item divided @click.native.prevent="newApplication"
            >{{ $t('new_search') }}
          </el-dropdown-item>
          <el-dropdown-item divided @click.native.prevent="logout"
            >{{ $t('logout') }}
          </el-dropdown-item>
          <!-- <el-dropdown-item>
            <el-select v-model="activeLocale" @change="changeLanguage">
              <el-option  v-for="locale in availableLocales" :key="locale" :label="locale"
                :value="locale" @click.native.prevent="changeLanguage">
              </el-option>
            </el-select>
          </el-dropdown-item> -->
        </el-dropdown-menu>
      </el-dropdown>
    </span>
  </div>
    <!-- <span class="header-logo hideInMd">
      <img :src="logoImage" @click="termsDialogVisible = !termsDialogVisible" /> -->
      <!-- <el-button type="text" @click="termsDialogVisible = !termsDialogVisible">e-Doatap</el-button> -->
    <!-- </span> -->
    <!-- <el-dialog
      title="ΟΡΟΙ ΚΑΙ ΠΡΟΫΠΟΘΕΣΕΙΣ ΧΡΗΣΗΣ ΤΟΥ e-doatap"
      :visible.sync="termsDialogVisible"
    >
    </el-dialog> -->
  </div>
</template>

<script>
// import NotificationsDialog from './common/notificationsDialog'
import Countdown from './common/Countdown'
import 'element-ui/lib/theme-chalk/display.css'
import router from '../router/index'
import axios from 'axios'
import config from '../config.js'
import logoImage from '@/assets/logo.png'
import sharedMethods from './common/sharedMethods.js'
import Chat from './common/chat/Chat'
import { mapGetters } from 'vuex'

export default {
  props: ['currentUser', 'usersAllApplications', 'startTimer'],
  name: 'Navbar',
  mixins: [sharedMethods],
  mounted: function() {
    if (JSON.parse(sessionStorage.getItem('refreshed'))) {
      this.time = JSON.parse(sessionStorage.getItem('timer'))
    }
  },
  updated: function() {},
  components: {
    // NotificationsDialog,
    Countdown,
    Chat
  },
  data() {
    return {
      chatDialogVisible: false,
      logoImage: logoImage,
      termsDialogVisible: false,
      timerNotificationShown: false,
      time: 3600,
      timer: null,
      selectApplication:
        this.usersAllApplications.length !== 0
          ? this.usersAllApplications[this.usersAllApplications.length - 1].id
          : '',
      activeApplication: '',
      pendingNotifications: [],
      allNotifications: [],
      loadingNotifications: false,
      pendingNotificationsExist: true,
      availableLocales: ['en', 'el'],
    }
  },
  computed: {
    notifications() {
      return this.$t('notifications')
    },
    newWord() {
      return this.$t('newWord') //'νέα'
    },
    prettyTime() {
      let time = this.time / 60
      let minutes = parseInt(time)
      let seconds = Math.round((time - minutes) * 60)
      return `${minutes} : ${seconds}`
    },
    existsApplications() {
      return !!this.usersAllApplications
    },
    activeLocale: {
      get() {
        return this.$i18n.locale
      },
      set(locale) {
        this.$i18n.locale = locale
      },
    },
    notificationsType() {
      return this.pendingNotificationsExist ? 'danger' : 'info'
    },
    ...mapGetters({
      appHasRoom: 'appHasRoom',
      haveNewMessages: 'haveNewMessages',
    })
  },
  methods: {
    newApplicationSelected(app) {
      this.selectApplication = app
      this.$store.dispatch('GET_APPLICATION', {id: app})
      this.$emit('newApplicationSelected', app)
    },
    sawNotifications() {
      // when seen re-color the button
      this.pendingNotificationsExist = false
    },
    listAllNotifications() {
      if (this.appHasRoom) {
        this.chatDialogVisible = true
      }
      // this.loadingNotifications = true
      // setTimeout(() => {
      //   this.allNotifications = [
      //     {
      //       date: '2016-05-02',
      //       name: 'John Smith',
      //       address: 'No.1518,  Jinshajiang Road, Putuo District',
      //     },
      //     {
      //       date: '2016-05-04',
      //       name: 'John Smith',
      //       address: 'No.1518,  Jinshajiang Road, Putuo District',
      //     },
      //   ]
      //   this.chatDialogVisible = true
      //   this.loadingNotifications = false
      // }, 2000)
    },
    login() {},
    newApplication() {
      this.selectApplication = ''
      this.$emit('newApplication')
      router.replace('/login')
    },
    logout() {
      return axios
        .post(
          `${config.BASE_URL}/logout`,
          {}
        )
        .then(response => {
          delete sessionStorage.token
          this.$emit('logout', this.currentUser)
          window.location.href = config.ENTRANCE_URL
        })
        .catch(err => {
          delete sessionStorage.token
          this.$emit('logout', this.currentUser)
          this.backendErrorNotify(err)
          // router.replace('/')
          window.location.href = config.ENTRANCE_URL
        })
    },
  },
  watch: {
    // whenever value changes, this function will run
    usersAllApplications: function(newVal) {
      // this.usersAllApplications = newVal
      this.$nextTick(function() {})
      if (newVal !== undefined && newVal.length !== 0) {
        this.selectApplication = newVal[newVal.length - 1].id
      }
    },
    startTimer: function(newVal) {
      if (newVal) {
        if (this.time < 60) {
          this.$notify.warning({
            title: this.$t('warning'),
            message: this.$t('session_expire_msg'),
            offset: 100,
          })
        }
        this.timer = setInterval(() => {
          if (this.time > 0) {
            this.time--
            sessionStorage.setItem('timer', this.time)
          } else {
            clearInterval(this.timer)
            // this.sound.play()
            this.logout()
          }
        }, 1000)
      }
    },
    time: function(newVal) {
      if (newVal < 60 && !this.timerNotificationShown) {
        this.$notify.warning({
          title: this.$t('warning'),
          message: this.$t('session'),
          duration: 0,
          offset: 100,
        })
        this.timerNotificationShown = true
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/variables.scss';

@media only screen and (max-width: $screen-md-min) {
  .hideInMd {
    display: none;
  }
}
@media only screen and (min-width: $screen-md-min) {
  .showInMd {
    display: none;
  }
}

.small-margin {
  margin: 10px;
}

.el-dropdown-link {
  cursor: pointer;
  color: #5468a9;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.navbar-user {
  float: center;
  padding-right: 10px;
}
.clock {
  border-radius: 5px 15px;
  border: 2px solid #7fa3bb;
  padding: 5px 10px;
  color: #fff;
}
.navbar-account {
  float: right;
  padding-right: 10px;
  height: 100%;
}
.header-logo {
  float: left;
  padding-top: 5px;
  padding-right: 2px;
  height: 100%;
}
// .el-header,
// .el-footer {
//   background-color: #b3c0d1;
//   color: #333;
//   text-align: center;
//   line-height: 60px;
//   padding: 0 20px;
//   -webkit-box-sizing: border-box;
//   box-sizing: border-box;
//   -ms-flex-negative: 0;
//   flex-shrink: 0;
//   border-radius: 4px;
// }
.bg-doatap {
  background: #605b56 !important;
}
.btn-logout {
  background-color: #837a75;
  border-color: #837a75;
  color: #fff;
}
.btn-logout:hover {
  background-color: darken(#837a75, 20%);
  border-color: darken(#837a75, 20%);
  color: #fff;
}
</style>
